<div class="onboarding-container">
    <app-language-selector class="absolute top-0 mt-3 right-0 mr-3 z-5"></app-language-selector>
    <div class="left-column flex flex-column justify-content-between">
        <div class="wave-content">
            <svg
                class="element-3"
                width="100%"
                height="109"
                viewBox="0 0 323 109"
                preserveAspectRatio="none"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M170.065 72.1857C242.821 62.3978 302.337 92.3052 323 108.482L323 0L-5.15513e-05 -2.82376e-05L-5.44749e-05 33.4419C26.3729 50.4348 97.3079 81.9735 170.065 72.1857Z"
                    [attr.fill]="mainColor" />
            </svg>
            <svg
                class="element-2"
                width="100%"
                height="110"
                viewBox="0 0 323 110"
                preserveAspectRatio="none"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M170.065 72.7618C242.821 62.974 302.337 92.8814 323 109.059L323 0.576172L-5.15513e-05 0.576144L-5.44749e-05 34.0181C26.3729 51.011 97.3079 82.5497 170.065 72.7618Z"
                    [attr.fill]="mainColor"
                    opacity="0.8" />
            </svg>
            <svg
                class="element-1"
                width="100%"
                height="109"
                viewBox="0 0 323 109"
                preserveAspectRatio="none"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M170.065 72.337C242.821 62.5491 302.337 92.4566 323 108.634L323 0.151367L-5.15513e-05 0.151339L-5.44749e-05 33.5933C26.3729 50.5862 97.3079 82.1249 170.065 72.337Z"
                    [attr.fill]="mainColor"
                    opacity="0.4" />
            </svg>
        </div>
        <div class="onboardwelcome">
            <h1>{{ 'home.onboarding.welcomeSection.title' | translate }}</h1>
            <p>{{ 'home.onboarding.welcome.subtitle' | translate }}</p>

            <ul class="features">
                <li>
                    <span class="material-symbols-outlined icon-lg feature-icon mr-3" aria-hidden="true"
                        >square_foot</span
                    >
                    <div class="flex flex-column">
                        <div>{{ 'home.onboarding.welcome.features.measure' | translate }}</div>
                        <img alt="Arrow left" class="arrow mt-2" src="assets/images/onboarding/Arrow1.svg" />
                    </div>
                </li>
                <li>
                    <span class="material-symbols-outlined icon-lg feature-icon mr-3" aria-hidden="true"
                        >query_stats</span
                    >
                    <div class="flex flex-column">
                        <div>{{ 'home.onboarding.welcome.features.analyze' | translate }}</div>
                        <img alt="Arrow right" class="arrow mt-2" src="assets/images/onboarding/arrow2.svg" />
                    </div>
                </li>
                <li>
                    <span class="material-symbols-outlined icon-lg feature-icon mr-3" aria-hidden="true"
                        >trending_down</span
                    >
                    <div class="flex flex-column">
                        <div>{{ 'home.onboarding.welcome.features.reduce' | translate }}</div>
                        <img alt="Arrow" class="arrow mt-2" src="assets/images/onboarding/arrow3.svg" />
                    </div>
                </li>
                <li>
                    <span class="material-symbols-outlined icon-lg feature-icon mr-3" aria-hidden="true"
                        >assignment</span
                    >
                    <div>{{ 'home.onboarding.welcome.features.report' | translate }}</div>
                </li>
            </ul>
            <p-button
                severity="secondary"
                [label]="'home.onboarding.welcome.contact' | translate"
                (onClick)="sendEmail()" />
        </div>
        <div class="wave-content">
            <svg
                class="bottom-element-1"
                width="100%"
                height="109"
                viewBox="0 0 323 109"
                preserveAspectRatio="none"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M152.936 36.663C80.1789 46.4508 20.6631 16.5434 -0.000244141 0.366211V108.849H323V75.4067C296.627 58.4138 225.692 26.8751 152.936 36.663Z"
                    [attr.fill]="mainColor"
                    opacity="0.4" />
            </svg>
            <svg
                class="bottom-element-2"
                width="100%"
                height="110"
                viewBox="0 0 323 110"
                preserveAspectRatio="none"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M152.936 37.2382C80.1789 47.026 20.6631 17.1186 -0.000244141 0.941406V109.424H323V75.9819C296.627 58.989 225.692 27.4503 152.936 37.2382Z"
                    [attr.fill]="mainColor"
                    opacity="0.8" />
            </svg>
            <svg
                class="bottom-element-3"
                width="100%"
                height="109"
                viewBox="0 0 323 109"
                preserveAspectRatio="none"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M152.936 36.8143C80.1789 46.6022 20.6631 16.6948 -0.000244141 0.517578V109H323V75.5581C296.627 58.5652 225.692 27.0264 152.936 36.8143Z"
                    [attr.fill]="mainColor" />
            </svg>
        </div>
    </div>
    <!-- Right Column: Form and Stepper -->
    <div class="right-column" [formGroup]="forms">
        <!-- Stepper -->
        <p-steps
            [(activeIndex)]="currentStep"
            [model]="steps"
            [readonly]="userFormGroup.invalid || organizationFormGroup.invalid || entityFormGroup.invalid"
            class="right-column--header"></p-steps>
        @switch (currentStep) {
            @case (0) {
                <div class="right-column--body welcome-step">
                    @if (config.showVideoOnboarding) {
                        <div>
                            <img height="30" src="assets/images/logo/logo-picto.webp" alt="" class="mt-3" />
                            <h2 class="section-title my-2">{{ 'home.onboarding.welcomeSection.title' | translate }}</h2>
                            <p class="m-0">{{ 'home.onboarding.welcomeSection.subTitle' | translate }}</p>
                            @if (lang === 'fr') {
                                <iframe
                                    class="welcome-video"
                                    src="https://www.loom.com/embed/a59f4b512ebd436d87e9f21549657d9e?sid=41304d78-a81f-40bd-b747-e9f24a8d8bd9"
                                    webkitallowfullscreen
                                    mozallowfullscreen
                                    allowfullscreen></iframe>
                            } @else {
                                <iframe
                                    class="welcome-video"
                                    src="https://www.loom.com/embed/114900095d6340c3abfce09644bc0fbd?sid=76607f4a-d91e-4c6a-8053-8c26233165f3"
                                    webkitallowfullscreen
                                    mozallowfullscreen
                                    allowfullscreen></iframe>
                            }
                        </div>
                    } @else {
                        <div class="flex flex-column align-items-center justify-content-center h-full gap-5">
                            <img height="50" src="assets/images/logo/logo-picto.webp" alt="" class="mt-3" />
                            <h2 class="text-4xl w-6 my-2">{{ 'home.onboarding.welcomeSection.title' | translate }}</h2>
                        </div>
                    }
                </div>
            }
            @case (1) {
                <div class="right-column--body" formGroupName="userGroup">
                    <div class="step-header">
                        <h2 class="section-title m-0">{{ 'home.onboarding.userSection.title' | translate }}</h2>
                        <p class="m-0 font-medium">{{ 'home.onboarding.userSection.subtitle' | translate }}</p>
                        <p class="form-field__help m-0">{{ 'home.onboarding.mandatory' | translate }}</p>
                    </div>
                    <div class="form-grid">
                        <div class="form-field">
                            <label for="lastname-input" class="form-field__label form-field__label--required">
                                {{ 'components.settingsForm.userSection.lastname.label' | translate }}
                            </label>
                            <input
                                pInputText
                                pAutoFocus
                                id="lastname-input"
                                type="text"
                                formControlName="lastname"
                                [placeholder]="
                                    'components.settingsForm.userSection.lastname.placeholder' | translate
                                " />
                            @if (
                                userFormGroup.get('lastname')?.invalid &&
                                userFormGroup.get('lastname')?.errors?.required &&
                                userFormGroup.get('lastname')?.touched
                            ) {
                                <small class="p-error">{{
                                    'common.forms.validationMessages.required' | translate
                                }}</small>
                            }
                        </div>
                        <div class="form-field">
                            <label for="firstname-input" class="form-field__label form-field__label--required">
                                {{ 'components.settingsForm.userSection.firstname.label' | translate }}
                            </label>
                            <input
                                pInputText
                                id="firstname-input"
                                type="text"
                                formControlName="firstname"
                                [placeholder]="
                                    'components.settingsForm.userSection.firstname.placeholder' | translate
                                " />
                            @if (
                                userFormGroup.get('firstname')?.invalid &&
                                userFormGroup.get('firstname')?.errors?.required &&
                                userFormGroup.get('firstname')?.touched
                            ) {
                                <small class="p-error">{{
                                    'common.forms.validationMessages.required' | translate
                                }}</small>
                            }
                        </div>
                        <div class="form-field">
                            <label for="email-input" class="form-field__label form-field__label--required">
                                {{ 'components.settingsForm.userSection.email.label' | translate }}
                            </label>
                            <input
                                pInputText
                                id="email-input"
                                type="text"
                                formControlName="email"
                                [placeholder]="'components.settingsForm.userSection.email.placeholder' | translate" />
                            @if (
                                userFormGroup.get('email')?.invalid &&
                                userFormGroup.get('email')?.errors?.required &&
                                userFormGroup.get('email')?.touched
                            ) {
                                <small class="p-error">{{
                                    'common.forms.validationMessages.required' | translate
                                }}</small>
                            }
                        </div>
                        <div class="form-field">
                            <!-- Required through phoneNumberValidator, which rejects an empty value. -->
                            <label for="phoneNumber-input" class="form-field__label form-field__label--required">
                                {{ 'components.settingsForm.userSection.phoneNumber.label' | translate }}
                            </label>
                            <input
                                pInputText
                                id="phoneNumber-input"
                                type="text"
                                formControlName="phoneNumber"
                                [placeholder]="
                                    'components.settingsForm.userSection.phoneNumber.placeholder' | translate
                                " />
                            @if (
                                userFormGroup.get('phoneNumber')?.invalid &&
                                userFormGroup.get('phoneNumber')?.errors?.required &&
                                userFormGroup.get('phoneNumber')?.touched
                            ) {
                                <small class="p-error">{{
                                    'common.forms.validationMessages.required' | translate
                                }}</small>
                            }
                            @if (
                                userFormGroup.get('phoneNumber')?.invalid &&
                                userFormGroup.get('phoneNumber')?.errors?.invalidPn &&
                                userFormGroup.get('phoneNumber')?.touched
                            ) {
                                <small class="p-error">{{
                                    'components.settingsForm.userSection.phoneNumber.validation.invalid' | translate
                                }}</small>
                            }
                        </div>
                        <div class="form-field">
                            <label for="role-input" class="form-field__label">
                                {{ 'components.settingsForm.userSection.role.label' | translate }}
                            </label>
                            <input
                                pInputText
                                id="role-input"
                                type="text"
                                formControlName="role"
                                [placeholder]="'components.settingsForm.userSection.role.placeholder' | translate" />
                        </div>
                    </div>
                </div>
            }
            @case (2) {
                <div class="right-column--body" formGroupName="organizationGroup">
                    <div class="step-header">
                        <h2 class="section-title m-0">
                            {{ 'home.onboarding.organiztionSection.title' | translate }}
                        </h2>
                        <p class="m-0 font-medium">{{ 'home.onboarding.organiztionSection.subtitle' | translate }}</p>
                        <p class="form-field__help m-0">{{ 'home.onboarding.mandatory' | translate }}</p>
                    </div>
                    <div class="form-grid">
                        <div class="form-field">
                            <label for="companyName-input" class="form-field__label form-field__label--required">
                                {{ 'components.settingsForm.companySection.companyName.label' | translate }}
                            </label>
                            <input
                                pInputText
                                pAutoFocus
                                id="companyName-input"
                                type="text"
                                formControlName="companyName"
                                [placeholder]="
                                    'components.settingsForm.companySection.companyName.placeholder' | translate
                                " />
                            @if (
                                organizationFormGroup.get('companyName')?.invalid &&
                                organizationFormGroup.get('companyName')?.errors?.required &&
                                organizationFormGroup.get('companyName')?.touched
                            ) {
                                <small class="p-error">{{
                                    'common.forms.validationMessages.required' | translate
                                }}</small>
                            }
                        </div>
                        <div class="form-field">
                            <label for="industry-input" class="form-field__label">
                                {{ 'components.settingsForm.companySection.industryCode.label' | translate }}
                            </label>
                            <p-select
                                inputId="industry-input"
                                [options]="industries"
                                formControlName="industryCode"
                                [placeholder]="
                                    'components.settingsForm.companySection.industryCode.placeholder' | translate
                                "
                                [showClear]="true"
                                [filter]="true"
                                filterBy="industrySectorId,label"
                                [resetFilterOnHide]="true"
                                optionValue="industrySectorId"
                                [emptyFilterMessage]="'common.filter.empty' | translate"
                                appendTo="body"
                                [panelStyle]="{ 'max-height': '300px' }"
                                [overlayOptions]="{ autoZIndex: true, baseZIndex: 1000 }"
                                [filterPlaceholder]="'common.search' | translate">
                                <ng-template let-sa pTemplate="selectedItem">
                                    {{ sa.label.length > 85 ? sa.label.slice(0, 85) + '...' : sa.label }}
                                </ng-template>
                                <ng-template let-activity pTemplate="item">
                                    <div>
                                        {{
                                            activity.label.length > 85
                                                ? activity.label.slice(0, 85) + '...'
                                                : activity.label
                                        }}
                                    </div>
                                </ng-template>
                            </p-select>
                            @if (
                                organizationFormGroup.get('industryCode')?.invalid &&
                                organizationFormGroup.get('industryCode')?.errors?.required &&
                                organizationFormGroup.get('industryCode')?.touched
                            ) {
                                <small class="p-error">{{
                                    'common.forms.validationMessages.required' | translate
                                }}</small>
                            }
                        </div>
                        <div class="form-field">
                            <label for="vatNumber-input" class="form-field__label">
                                {{ 'components.settingsForm.companySection.vatNumber.label' | translate }}
                                <span
                                    class="material-symbols-outlined icon-sm cursor-help label-info"
                                    [pTooltip]="'home.onboarding.organiztionSection.vatNumber.toolTip' | translate"
                                    >info</span
                                >
                            </label>
                            <p-iconfield iconPosition="right">
                                <input
                                    pInputText
                                    id="vatNumber-input"
                                    type="text"
                                    formControlName="vatNumber"
                                    [placeholder]="vatPlaceholder" />
                                @if (organizationFormGroup.get('vatNumber')?.value?.length > 0) {
                                    <p-inputicon>
                                        <button
                                            type="button"
                                            class="input-clear"
                                            [attr.aria-label]="'common.clear' | translate"
                                            (click)="clearInput(organizationFormGroup.get('vatNumber'))">
                                            <span class="material-symbols-outlined icon-sm" aria-hidden="true"
                                                >close</span
                                            >
                                        </button>
                                    </p-inputicon>
                                }
                            </p-iconfield>
                            @if (
                                organizationFormGroup.get('vatNumber')?.invalid &&
                                organizationFormGroup.get('vatNumber')?.errors?.invalidVat &&
                                organizationFormGroup.get('vatNumber')?.touched
                            ) {
                                <small class="p-error">{{
                                    'components.settingsForm.companySection.vatNumber.invalidVat'
                                        | translate: { vatFormat: vatPlaceholder }
                                }}</small>
                            }
                        </div>
                        <div class="form-field">
                            <label for="companyLogo-input" class="form-field__label">
                                {{ 'components.settingsForm.companySection.companyLogo.label' | translate }}
                            </label>
                            <app-image-selector
                                inputId="companyLogo-input"
                                accept="image/png, image/jpeg"
                                [maxFileSize]="5 * 1024 * 1024"
                                [label]="'components.settingsForm.button.imageUpload' | translate"
                                formControlName="companyLogo"
                                styleClass="flex align-items-center"
                                [placeholder]="userClaim.organization?.name?.substring(0, 2)"></app-image-selector>
                            <small class="form-field__help">
                                {{ 'components.settingsForm.companySection.companyLogo.accept' | translate }}
                            </small>
                            @if (
                                organizationFormGroup.get('companyLogo')?.invalid &&
                                organizationFormGroup.get('companyLogo')?.touched
                            ) {
                                @if (organizationFormGroup.get('companyLogo')?.errors?.invalidFileType) {
                                    <small class="p-error">{{
                                        'components.settingsForm.companySection.toasts.avatarUpload.invalideTypeFileError'
                                            | translate
                                    }}</small>
                                }
                                @if (organizationFormGroup.get('companyLogo')?.errors?.fileSizeExceeded) {
                                    <small class="p-error">{{
                                        'components.settingsForm.companySection.toasts.avatarUpload.maxFileSizeError'
                                            | translate
                                    }}</small>
                                }
                            }
                        </div>
                    </div>
                </div>
            }
            @case (3) {
                <div class="right-column--body" formGroupName="entityGroup">
                    <div class="step-header">
                        <h2 class="section-title m-0">{{ 'home.onboarding.entitySection.title' | translate }}</h2>
                        <p class="m-0 font-medium">{{ 'home.onboarding.entitySection.subtitle' | translate }}</p>
                        <p class="form-field__help m-0">{{ 'home.onboarding.mandatory' | translate }}</p>
                    </div>
                    <div class="form-grid form-grid--2">
                        <div class="form-field form-field--wide">
                            <label for="name-input" class="form-field__label form-field__label--required">
                                {{ 'components.settingsForm.entitySection.edit.name.label' | translate }}
                            </label>
                            <input
                                pInputText
                                pAutoFocus
                                id="name-input"
                                type="text"
                                formControlName="name"
                                [placeholder]="
                                    'components.settingsForm.entitySection.edit.name.placeholder' | translate
                                " />
                            @if (
                                entityFormGroup.get('name')?.invalid &&
                                entityFormGroup.get('name')?.errors?.required &&
                                entityFormGroup.get('name')?.touched
                            ) {
                                <small class="p-error">{{
                                    'common.forms.validationMessages.required' | translate
                                }}</small>
                            }
                        </div>
                        <div class="form-field form-field--wide">
                            <label
                                for="reporting-input"
                                class="form-field__label"
                                [class.form-field__label--required]="isRequired(entityFormGroup.get('refYear'))">
                                {{ 'home.onboarding.entitySection.reportingYear.label' | translate }}
                            </label>
                            <p-select
                                inputId="reporting-input"
                                [options]="periodList"
                                formControlName="refYear"
                                [placeholder]="'home.onboarding.entitySection.reportingYear.placeholder' | translate">
                            </p-select>
                            @if (
                                entityFormGroup.get('refYear')?.invalid &&
                                entityFormGroup.get('refYear')?.errors?.required &&
                                entityFormGroup.get('refYear')?.touched
                            ) {
                                <small class="p-error">{{
                                    'common.forms.validationMessages.required' | translate
                                }}</small>
                            }
                        </div>
                        <div class="form-field">
                            <label for="country-input" class="form-field__label form-field__label--required">
                                {{ 'components.settingsForm.entitySection.edit.country.label' | translate }}
                                <span
                                    class="material-symbols-outlined icon-sm cursor-help label-info"
                                    [pTooltip]="'home.onboarding.entitySection.country.infoTip' | translate"
                                    >info</span
                                >
                            </label>
                            <p-select
                                inputId="country-input"
                                [options]="countries"
                                formControlName="country"
                                (onChange)="onEntityCountryChange($event)"
                                [placeholder]="
                                    'components.settingsForm.entitySection.edit.country.placeholder' | translate
                                "
                                [filter]="true"
                                filterMatchMode="startsWith"
                                optionLabel="name"
                                optionValue="code"
                                [emptyFilterMessage]="'common.filter.empty' | translate"
                                [virtualScroll]="true"
                                [virtualScrollItemSize]="38"
                                [filterPlaceholder]="'common.search' | translate">
                            </p-select>
                            @if (
                                entityFormGroup.get('country')?.invalid &&
                                entityFormGroup.get('country')?.errors?.required &&
                                entityFormGroup.get('country')?.touched
                            ) {
                                <small class="p-error">{{
                                    'common.forms.validationMessages.required' | translate
                                }}</small>
                            }
                        </div>
                        <div class="form-field">
                            <label for="currency-input" class="form-field__label form-field__label--required">
                                {{ 'components.settingsForm.entitySection.edit.currency.label' | translate }}
                            </label>
                            <p-select
                                inputId="currency-input"
                                [options]="currencyOptions"
                                formControlName="currency"
                                optionLabel="label"
                                optionValue="code"
                                [placeholder]="
                                    'components.settingsForm.entitySection.edit.currency.placeholder' | translate
                                ">
                            </p-select>
                            @if (
                                entityFormGroup.get('currency')?.invalid &&
                                entityFormGroup.get('currency')?.errors?.required &&
                                entityFormGroup.get('currency')?.touched
                            ) {
                                <small class="p-error">{{
                                    'common.forms.validationMessages.required' | translate
                                }}</small>
                            }
                        </div>
                        <div class="form-field form-field--wide">
                            <label for="revenue-input" class="form-field__label">
                                {{ 'home.onboarding.entitySection.revenue.label' | translate }}
                                <span
                                    class="material-symbols-outlined icon-sm cursor-help label-info"
                                    [pTooltip]="'home.onboarding.entitySection.revenue.toolTip' | translate"
                                    >info</span
                                >
                            </label>
                            <input
                                pInputText
                                id="revenue-input"
                                type="text"
                                formControlName="annualRevenue"
                                pKeyFilter="num"
                                [placeholder]="'home.onboarding.entitySection.revenue.placeholder' | translate" />
                        </div>
                        <div class="form-field form-field--wide">
                            <label for="fte-input" class="form-field__label">
                                {{ 'home.onboarding.entitySection.fte.label' | translate }}
                                <span
                                    class="material-symbols-outlined icon-sm cursor-help label-info"
                                    [pTooltip]="'home.onboarding.entitySection.fte.tooltip' | translate"
                                    >info</span
                                >
                            </label>
                            <p-inputNumber
                                inputId="fte-input"
                                formControlName="fte"
                                [min]="1"
                                [placeholder]="
                                    'components.settingsForm.entitySection.edit.fte.placeholder' | translate
                                "></p-inputNumber>
                            @if (
                                entityFormGroup.get('fte')?.invalid &&
                                entityFormGroup.get('fte')?.errors?.required &&
                                entityFormGroup.get('fte')?.touched
                            ) {
                                <small class="p-error">{{
                                    'common.forms.validationMessages.required' | translate
                                }}</small>
                            }
                        </div>
                    </div>
                </div>
            }
        }
        <div class="right-column--footer form-actions">
            <!-- On the first step the way out is to log out. -->
            @if (currentStep === 0) {
                <p-button
                    severity="secondary"
                    [label]="'home.onboarding.buttons.cancel' | translate"
                    (onClick)="logout()" />
            } @else {
                <p-button
                    severity="secondary"
                    icon="ms ms-arrow_back"
                    [label]="'home.onboarding.buttons.back' | translate"
                    (onClick)="previousStep()" />
            }
            @if (currentStep < 3) {
                <p-button [label]="'home.onboarding.buttons.next' | translate" (onClick)="nextStep()" />
            } @else {
                <p-button
                    [label]="'home.onboarding.buttons.submit' | translate"
                    [loading]="loading"
                    (onClick)="onSubmit()" />
            }
        </div>
    </div>
</div>
